import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/tracker";

const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Skip admin pages
    if (location.pathname.startsWith("/admin")) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
};

export default PageViewTracker;
